import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import capitalize from 'lodash/capitalize'

import Grid from '@mui/material/Grid'

import { HHFormTextField } from 'components/form-fields/v5'

import T from 'T'
import { DEFAULT_ADDRESS_FIELD_KEY, DEFAULT_STATE } from './model'

const { cityPlaceholder, statePlaceholder, zipCodePlaceholder } = DEFAULT_STATE

const AddressRowTwo = ({ fieldPrefix = DEFAULT_ADDRESS_FIELD_KEY, control, hasError = {}, required = false, onKeyDown = noop }) => {
  return (
    <Grid sx={{ width: '100%' }} container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <HHFormTextField
          control={control}
          name={`${fieldPrefix}.city`}
          label={T.CITY}
          placeholder={cityPlaceholder}
          required={required}
          error={Boolean(hasError.city)}
          helperText={hasError.city?.message}
          fullWidth
          deprecatedLabel={false}
          onKeyDown={onKeyDown}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <HHFormTextField
          control={control}
          name={`${fieldPrefix}.state`}
          label={T.STATE}
          placeholder={statePlaceholder}
          required={required}
          error={Boolean(hasError.state)}
          helperText={hasError.state?.message}
          fullWidth
          deprecatedLabel={false}
          onKeyDown={onKeyDown}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <HHFormTextField
          control={control}
          name={`${fieldPrefix}.zipCode`}
          label={capitalize(T.ZIP_CODE)}
          placeholder={zipCodePlaceholder}
          error={Boolean(hasError.zipCode)}
          helperText={hasError.zipCode?.message}
          fullWidth
          deprecatedLabel={false}
          onKeyDown={onKeyDown}
        />
      </Grid>
    </Grid>
  )
}

AddressRowTwo.propTypes = {
  fieldPrefix: PropTypes.string,
  control: PropTypes.object.isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.shape({
    city: PropTypes.any,
    state: PropTypes.any,
    zipCode: PropTypes.any,
  }),
  onKeyDown: PropTypes.func,
}

export default AddressRowTwo
